var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 44,
    viewBox: "0 0 46 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Fill"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.855469 0.0703125H40.4309C43.4114 0.0703125 45.8275 2.48647 45.8275 5.46696V39.0334C45.8275 42.0139 43.4114 44.43 40.4309 44.43H0.855469V0.0703125Z",
    fill: "#12110B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.855469 0.0703125H40.4309C43.4114 0.0703125 45.8275 2.48647 45.8275 5.46696V39.0334C45.8275 42.0139 43.4114 44.43 40.4309 44.43H0.855469V0.0703125Z",
    stroke: "#D6D6D6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFill);
export default __webpack_public_path__ + "static/media/Fill.1bdf31094b7882ad93d3055da101f0c1.svg";
export { ForwardRef as ReactComponent };